import React, { Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Input } from '../../../../components/fields';
import RequestFormAutocompleteList from './List';
import s from './index.css';

const propTypes = {
    onChange: PropTypes.func.isRequired,
    maxAccordionHeight: PropTypes.number.isRequired,
    searchPlaceholder: PropTypes.string.isRequired,
    values: PropTypes.arrayOf(
        PropTypes.shape({
            reportParamValue: PropTypes.string,
            reportParamDesc: PropTypes.string,
        })
    ).isRequired,
    selected: PropTypes.any,
    expanded: PropTypes.bool,
};

class RequestFormAutocompleteParam extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            search: '',
        };
    }

    refInputComponent = createRef();
    refAutocompleteList = createRef();

    componentWillReceiveProps(nextProps) {
        const beforeExpanded = this.props.expanded ? true : false;
        const afterExpanded = nextProps.expanded ? true : false;

        if (
            afterExpanded &&
            beforeExpanded !== afterExpanded &&
            this.refInputComponent &&
            this.refInputComponent.current
        ) {
            this.refInputComponent.current.focusOnField();
        }
    }

    render() {
        return (
            <div className={s.autocomplete}>
                <div className={s.searchContainer}>
                    <Input
                        ref={this.refInputComponent}
                        placeholder={this.props.searchPlaceholder}
                        onChange={this.handleSearchChange}
                        value={this.state.search}
                        design="darker"
                    />
                </div>

                <div
                    ref={this.refAutocompleteList}
                    className={s.autocompleteList}
                    style={{ maxHeight: this.props.maxAccordionHeight || undefined }}
                >
                    <RequestFormAutocompleteList
                        onChange={this.handleSelectedChange}
                        values={this.props.values}
                        search={this.state.search}
                        selected={this.props.selected}
                    />
                </div>
            </div>
        );
    }

    handleSearchChange = e => {
        this.setState({
            search: e.target.value,
        });

        if (this.refAutocompleteList && this.refAutocompleteList.current) {
            this.refAutocompleteList.current.scrollTop = 0;
        }
    };

    handleSelectedChange = selected => {
        this.setState({
            search: '',
        });

        if (this.refAutocompleteList && this.refAutocompleteList.current) {
            this.refAutocompleteList.current.scrollTop = 0;
        }

        this.props.onChange(selected.value, selected.name);
    };
}

RequestFormAutocompleteParam.propTypes = propTypes;

export default connect()(RequestFormAutocompleteParam);



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportPage/Form/Autocomplete/index.jsx